///<reference path="../../components/short-cuts/models/short-cuts-state-manager.controller.ts"/>
///<reference path="../AppointmentBook/js/controllers/AppointmentBook.ts"/>
///<reference path="inventoryTransferNote.controller.ts"/>

module Meevo.Plugins.InventoryTransfer {

    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import ISelectItem = Meevo.Model.ISelectItem;   

    class InventoryTransferController extends ShortCutsStateManagerController {

        closeContext: Function;
        context: InventoryTransferContext;
        mobileView: any = 'editCount';
        protected onHandValue: number;
        public inventoryTransferId: string;
        public showAdvancedMobile: boolean;
        protected noteText : string;
        protected shortCutGroup: { [key: number]: IShortCutGroup };
        public transferringLocationId: number;
        public receivingLocationId: number;
        get noun() {
            return Meevo.Model.NounEnum.InventoryTransfer;
        }

        get mode(): Meevo.Model.MaintenanceFormState {
            return this.context.mode;
        }

        static $inject = [
            "meevo.AppSettings", "meevo.components.common.DataService",
            "meevo.components.modal.ModalService", "$rootScope", "$state",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.IdentityService",
            "$q", "$timeout", "$filter",
            "meevo.components.common.ReportRouterService", "$mdSidenav", "$translate", '$scope',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.RoundingService',
            'meevo.plugins.inventoryTransfer.LotModalBridge'
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.ModalService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected securityChecker: Meevo.Components.Common.SecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected $q: ng.IQService,
            protected $timeout: ng.ITimeoutService,
            protected $filter: angular.IFilterService,
            protected reportRouterService: Meevo.Components.Common.ReportRouterService,
            private $mdSidenav: any,
            protected $translate: ng.translate.ITranslateService,
            protected $scope: ng.IScope,
            protected shortCutsService: IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected lotModalBridge: LotModalBridge) {
            super($scope, $state, shortCutsService);

            //this.dialog = $mdDialog;
            let vm = this;
            vm.onHandValue = 0;
            vm.context = new InventoryTransferContext(appSettings, dataService, modalService, this, securityChecker, trackingService, this.identityService, $q, $timeout, $filter, this.reportRouterService, $mdSidenav, $translate, $rootScope, $scope, busyService, this.roundingService, lotModalBridge);
            vm.closeContext = (): void => {
               this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);               
            }
            vm.noteText = "";
            vm.showAdvancedMobile = false;
            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Pending]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_ADD',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        $timeout(() => {
                            $('button[meevo-btn-sc="DATA_MAINTENANCE_ADD"]:visible').click();
                        });
                        this.context.preventUsageTracking = false;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                       this.context.edit(); 
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.delete(this.context.inventoryTransfer.id);
                        this.context.preventUsageTracking = false;
                    }
                    }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.save();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.cancel();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.delete(this.context.inventoryTransfer.id);
                        this.context.preventUsageTracking = false;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Adding]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.save();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.delete(this.context.inventoryTransfer.id);
                        this.context.preventUsageTracking = false;
                    }
                }])
            };
        }

        viewSwitch = (view: any): void => {
            this.mobileView = view;
        }
        showAddNoteModal() {
            let scope = this;
            this.showNoteModal(null).then((d) => {
                if (d) {
                    this.$timeout(() => {
                        scope.context.getNotes(this.context.inventoryTransferId);//.infiteitems.loadedPages[0].unshift(d);
                    }, 1);
                }
            });
        };
        showEditNoteModal(item: any) {
            let scope = this;
            item.isLocationFromAndTo = item.isLocationFrom && item.isLocationTo;
            this.showNoteModal(angular.copy(item)).then((returnNote) => {
                if (returnNote) {
                    item.note = returnNote;                    
                    scope.context.getNotes(this.context.inventoryTransferId);
                }
            });
        };
        showNoteModal(itemNote: any): ng.IPromise<any> {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/inventoryTransfer/sectionViews/noteTemplate.html",
                controller: "meevo.plugins.inventoryTransfer.inventoryTransferNoteController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    inventoryTransferId: this.context.inventoryTransferId,
                    note: itemNote,
                    transferringLocationId: this.context.transferringLocationId,
                    receivingLocationId: this.context.receivingLocationId,
                    currentLocationId: this.context.currentLocationId,
                    isCoLocation: this.context.isCo,
                    preventUsageTracking: this.context.preventUsageTracking
                },
                resolve: {
                    value: function () {
                    }
                }
            };
            return this.modalService.showCustom(options);
        }
        closeCustomModal(): void {
            this.modalService.hide();
        }
        submitCustomModal(): void {
            this.modalService.hideWithResponse(this.onHandValue);
        }
        toggleShowAdvancedMobile = (): void => {
            this.showAdvancedMobile = !this.showAdvancedMobile;
        }
    }

    angular.module("meevo.plugins.inventoryTransfer")
        .controller("meevo.plugins.inventoryTransfer.InventoryTransferController", InventoryTransferController);
}
